import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n/I18n';

import '@/plugins/sentry';
import '@/plugins/lightgallery';
import '@/assets/styles/main.scss';
import VModal from 'vue-js-modal';
import PortalVue from 'portal-vue';
import 'vue-js-modal/dist/styles.css';
import VueGtm from 'vue-gtm';

Vue.config.productionTip = false;

Vue.use(VModal, { inheritAttrs: false });
Vue.use(PortalVue);

if (process.env.VUE_APP_GOOGLE_TAG_KEY) {
    Vue.use(VueGtm, {
        id: process.env.VUE_APP_GOOGLE_TAG_KEY,
        debug: process.env.NODE_ENV !== 'production',
        loadScript: true,
        vueRouter: router,
        trackOnNextTick: false,
    });
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
